import React, { memo, ReactNode } from 'react';
import { Virtual, Navigation, Pagination, FreeMode } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/virtual';

interface IProps<T> {
    data: T[];
    itemRenderer: (data: T) => ReactNode;
    itemsGap?: number;
    itemsPerView?: number | 'auto';
    centeredItem?: boolean;
    virtual?: boolean;
    infinite?: boolean;
    navigation?: boolean;
    pagination?: boolean;
    className?: string;
    freeMode?: boolean;
    threshold?: number;
}

export function Carousel<T>({
    data = [],
    itemRenderer,
    itemsGap = 16,
    itemsPerView = 'auto',
    centeredItem = false,
    virtual = false,
    infinite = false,
    navigation = false,
    pagination = false,
    freeMode = false,
    threshold,
    className,
}: IProps<T>) {
    const swiperSettings = {
        spaceBetween: itemsGap,
        slidesPerView: itemsPerView,
        centeredSlides: centeredItem,
        modules: [Virtual, Navigation, Pagination, FreeMode],
        virtual: virtual,
        loop: infinite,
        navigation: navigation,
        pagination: pagination,
        freeMode: freeMode,
        threshold: threshold,
        resistanceRatio: 0.5,
    };

    const renderSlides = () => {
        return data.map((data: T, index: number) => (
            <SwiperSlide key={index}>{itemRenderer(data)}</SwiperSlide>
        ));
    };

    return (
        <Swiper className={className} {...swiperSettings}>
            {renderSlides()}
        </Swiper>
    );
}

export default memo(Carousel) as typeof Carousel;
